import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Field, Form, Formik } from 'formik'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import { isEmpty } from 'lodash'

import Modal from 'components/Modal'

import ToggleButton from 'components/ToggleButton'
import {
  getLocationSettings,
  getRevenueCenter,
} from 'store/RevenueCenters/selector'
import { addLocationSettings } from 'store/RevenueCenters/actions'

const LocationSettings = () => {
  const { revenueCenterId } = useParams()

  const currentRevenueCenter = useSelector((state) =>
    getRevenueCenter(state, revenueCenterId)
  )
  const storedLocationSettings = useSelector(getLocationSettings)

  const { provideTipSuggestions, androidPayMerchantId } =
    storedLocationSettings

  const initialValues = {
    provideTipSuggestions: provideTipSuggestions ?? false,
    androidPayMerchantId: androidPayMerchantId ?? '',
  }

  const dispatch = useDispatch()
  const history = useHistory()

  const onCloseModal = () => {
    history.goBack()
  }

  const onSubmit = ({
    provideTipSuggestions,
    androidPayMerchantId,
  }) => {
    const locationSettingsData = {
      provideTipSuggestions,
      androidPayMerchantId,
    }

    dispatch(addLocationSettings(locationSettingsData))
    history.push(`/revenue-centers/${revenueCenterId}`)
  }

  useEffect(() => {
    const locationSettingsData = {
      provideTipSuggestions:
        currentRevenueCenter?.provideTipSuggestions ?? false,
      androidPayMerchantId:
        currentRevenueCenter?.androidPayMerchantId ?? '',
    }
    isEmpty(storedLocationSettings) &&
      dispatch(addLocationSettings(locationSettingsData))
  }, [currentRevenueCenter])

  return (
    <Modal
      title="Location Settings"
      onClose={onCloseModal}
      className="-narrow"
    >
      <div className="modal-body">
        <Formik
          enableReinitialize
          initialValues={initialValues}
          onSubmit={onSubmit}
        >
          {({ values, setFieldValue }) => (
            <Form>
              <div className="item-settings">
                <section>
                  <div className="content-wrapper -more-space">
                    <div className="content-header ">
                      Tip Suggestions
                    </div>
                    <Field
                      component={ToggleButton}
                      name="provideTipSuggestions"
                      value={values?.provideTipSuggestions}
                      onChange={(val) =>
                        setFieldValue('provideTipSuggestions', val)
                      }
                    />
                  </div>
                </section>
                <div className="btn-wrapper">
                  <button className="btn -update" type="submit">
                    Save
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Modal>
  )
}

export default LocationSettings
